module.exports = __webpack_public_path__ + "static/other/ride_mechanic.4f6a9555.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/ride_mechanic.json
// module id = 2634
// module chunks = 0